const COOKIE_NAME = 'beisler_konfig';
const KEYS = ['wand', 'boden', 'front', 'abdeckung'];
const MQ_DESKTOP = '(min-width: 891px)';

function defaults() {
    return window.lmKonfigDefaults && typeof window.lmKonfigDefaults === 'object' ? { ...window.lmKonfigDefaults } : {};
}

function isFlatCookie(data) {
    return KEYS.some((key) => typeof data[key] === 'string' && data[key]);
}

function parseCookieObject() {
    const match = document.cookie.split('; ').find((row) => row.startsWith(`${COOKIE_NAME}=`));
    let parsed = {};
    if (match) {
        try {
            parsed = JSON.parse(decodeURIComponent(match.split('=').slice(1).join('='))) || {};
        } catch (error) {
            parsed = {};
        }
    } else if (window.lmKonfigCookie && typeof window.lmKonfigCookie === 'object') {
        parsed = { ...window.lmKonfigCookie };
    }
    if (!isFlatCookie(parsed)) {
        return {};
    }
    const out = {};
    KEYS.forEach((key) => {
        if (typeof parsed[key] === 'string' && parsed[key]) {
            out[key] = parsed[key];
        }
    });
    return out;
}

function optionValues(key) {
    const values = [];
    document.querySelectorAll(`.js-konfig-option[data-filter-slug="${key}"]`).forEach((el) => {
        if (el.dataset.value && values.indexOf(el.dataset.value) === -1) {
            values.push(el.dataset.value);
        }
    });
    return values;
}

function readCookie() {
    const parsed = parseCookieObject();
    const out = {};
    KEYS.forEach((key) => {
        const value = parsed[key];
        if (!value) {
            return;
        }
        const allowed = optionValues(key);
        if (!allowed.length || allowed.indexOf(value) !== -1) {
            out[key] = value;
        }
    });
    return out;
}

function writeCookie(data) {
    const expires = new Date();
    expires.setDate(expires.getDate() + 30);
    const cleaned = {};
    KEYS.forEach((key) => {
        if (data[key]) {
            cleaned[key] = data[key];
        }
    });
    document.cookie = `${COOKIE_NAME}=${encodeURIComponent(JSON.stringify(cleaned))}; path=/; expires=${expires.toUTCString()}; SameSite=Lax`;
    window.lmKonfigCookie = cleaned;
}

function persistValidCookie() {
    const raw = parseCookieObject();
    const cleaned = readCookie();
    const changed = KEYS.some((key) => (raw[key] || '') !== (cleaned[key] || ''));
    if (changed) {
        writeCookie(cleaned);
    }
}

export function getKonfig() {
    return { ...defaults(), ...readCookie() };
}

export function clearKonfig() {
    writeCookie({});
    syncUI();
    applyKonfigImages();
}

export function setKonfigValue(key, value) {
    const data = readCookie();
    if (value) {
        data[key] = value;
    } else {
        delete data[key];
    }
    writeCookie(data);
    applyKonfigImages();
}

let pageKueche = 'ks1';
const kuecheListeners = [];

function normalizeKueche(code) {
    return code === 'ks2' ? 'ks2' : 'ks1';
}

function hasKuecheFilter() {
    return !!document.querySelector('.js-konfig-option[data-filter-slug="kueche"]');
}

function applyKuecheSlotVisibility() {
    if (!hasKuecheFilter()) {
        return;
    }
    const current = pageKueche;
    document.querySelectorAll('.js-konfig-image[data-konfig-kueche]').forEach((el) => {
        el.hidden = el.dataset.konfigKueche !== current;
    });
}

export function getKuecheStandort() {
    return pageKueche;
}

export function onKuecheStandortChange(fn) {
    kuecheListeners.push(fn);
}

export function setKuecheStandort(code) {
    const next = normalizeKueche(code);
    if (pageKueche === next) {
        return;
    }
    pageKueche = next;
    syncUI();
    kuecheListeners.forEach((fn) => fn(next));
    revealKuecheSlots(next);
}

function segmentOrder() {
    return window.lmKonfigOrder && window.lmKonfigOrder.length ? window.lmKonfigOrder : KEYS;
}

function isCloseupScene(scene) {
    return String(scene || '')
        .toLowerCase()
        .indexOf('cu') === 0;
}

function codeKeyMap() {
    return window.lmKonfigCodeKeys && typeof window.lmKonfigCodeKeys === 'object' ? window.lmKonfigCodeKeys : {};
}

function codesForKey(key) {
    const map = codeKeyMap();
    const out = [];
    Object.keys(map).forEach((code) => {
        if (map[code] === key && out.indexOf(code) === -1) {
            out.push(code);
        }
    });
    if (key === 'kueche' && out.indexOf('ks') === -1) {
        out.unshift('ks');
    }
    return out.length ? out : optionValues(key);
}

function basenameHasCode(base, code) {
    return String(base)
        .split('-')
        .indexOf(String(code)) !== -1;
}

const scenePatternCache = {};

function scenePattern(scene, files) {
    const slug = String(scene || '').toLowerCase();
    if (scenePatternCache[slug]) {
        return scenePatternCache[slug];
    }
    const prefix = `di-${slug}-`;
    const map = codeKeyMap();
    const bases = Object.keys(files || {}).filter((base) => base.indexOf(prefix) === 0);
    if (!bases.length) {
        scenePatternCache[slug] = [];
        return scenePatternCache[slug];
    }
    const sample = bases[0].split('-');
    const pattern = [];
    const slots = [];
    sample.slice(2).forEach((code, offset) => {
        const key = map[code];
        if (!key) {
            return;
        }
        pattern.push({ key, placeholder: '' });
        slots.push(offset + 2);
    });
    pattern.forEach((seg, index) => {
        const partI = slots[index];
        const seen = {};
        bases.forEach((base) => {
            const code = String(base).split('-')[partI] || '';
            if (code) {
                seen[code] = true;
            }
        });
        const unique = Object.keys(seen);
        if (unique.length === 1) {
            seg.placeholder = unique[0];
        }
    });
    scenePatternCache[slug] = pattern;
    return pattern;
}

function basenameForScene(scene, codes, files) {
    const slug = String(scene).toLowerCase();
    const pattern = scenePattern(slug, files || window.lmKonfigFiles || {});
    if (pattern.length) {
        return ['di', slug, ...pattern.map((seg) => (seg.placeholder ? seg.placeholder : codes[seg.key] || ''))]
            .filter(Boolean)
            .join('-');
    }
    if (isCloseupScene(slug)) {
        return ['di', slug, codes.front || '', codes.abdeckung || ''].filter(Boolean).join('-');
    }
    return ['di', slug, ...segmentOrder().map((key) => codes[key] || '')].filter(Boolean).join('-');
}

function bestUrlForScene(scene, codes, files) {
    const exact = basenameForScene(scene, codes, files);
    if (files[exact]) {
        return files[exact];
    }
    const prefix = `di-${String(scene).toLowerCase()}-`;
    let candidates = Object.keys(files).filter((base) => base.indexOf(prefix) === 0);
    if (!candidates.length) {
        return '';
    }
    const keys = segmentOrder();
    const locked = {};
    scenePattern(String(scene).toLowerCase(), files).forEach((seg) => {
        if (seg.placeholder) {
            locked[seg.key] = true;
        }
    });
    for (let i = 0; i < keys.length; i += 1) {
        const key = keys[i];
        const want = codes[key];
        if (!want || locked[key]) {
            continue;
        }
        const valid = codesForKey(key);
        const dimensionPresent = valid.length
            ? candidates.some((base) => valid.some((code) => basenameHasCode(base, code)))
            : false;
        const filtered = candidates.filter((base) => basenameHasCode(base, want));
        if (filtered.length) {
            candidates = filtered;
        } else if (dimensionPresent) {
            return '';
        }
    }
    return files[candidates[0]] || '';
}

function canonicalDiBasename(filename) {
    let base = String(filename || '')
        .split('?')[0]
        .split('#')[0]
        .replace(/^.*\//, '')
        .replace(/\.[^.]+$/, '')
        .toLowerCase()
        .trim();
    if (base.indexOf('di-') !== 0) {
        return '';
    }
    base = base
        .replace(/-scaled$/, '')
        .replace(/-\d+x\d+(-f\d+_\d+|-c|-fd)?$/, '')
        .replace(/_/g, '-');
    const parts = base.split('-');
    if (parts.length > 7) {
        return parts.slice(0, 7).join('-');
    }
    return parts.join('-');
}

function focalPositionForUrl(url) {
    const base = urlBasename(url);
    const map = window.lmKonfigFocalPoints || {};
    const fp = (base && map[base]) || null;
    if (!fp || fp.length < 2) {
        return '';
    }
    return `${Number(fp[0]) * 100}% ${Number(fp[1]) * 100}%`;
}

function applyFocalPoint(img, url) {
    if (!img) {
        return;
    }
    const pos = focalPositionForUrl(url);
    if (pos) {
        img.style.objectPosition = pos;
    }
}

function isBisCropSrc(src) {
    return String(src || '').indexOf('/bis-images/') !== -1;
}

function urlBasename(url) {
    try {
        return canonicalDiBasename(decodeURIComponent(url));
    } catch (error) {
        return canonicalDiBasename(url);
    }
}

function slotDisplayUrl(el) {
    const img = el.querySelector('img');
    if (!img) {
        return '';
    }
    const srcAttr = img.getAttribute('src');
    if (srcAttr) {
        return img.currentSrc || srcAttr;
    }
    return img.getAttribute('data-src') || '';
}

function sameCombo(el, url) {
    const current = slotDisplayUrl(el);
    if (!current || !url) {
        return false;
    }
    const a = urlBasename(current);
    const b = urlBasename(url);
    if (a && b) {
        return a === b;
    }
    return current === url;
}

function isDeferredSlot(el) {
    return !!(el.hidden || el.closest('[hidden]'));
}

function targetUrlForSlot(el, files) {
    const scene = el.dataset.konfigScene;
    if (!scene) {
        return '';
    }
    const codes = { ...getKonfig() };
    if (el.dataset.konfigKueche) {
        codes.kueche = el.dataset.konfigKueche;
    }
    return bestUrlForScene(scene, codes, files) || el.dataset.fallbackUrl || '';
}

function updateLinkHref(el, url) {
    const link = el.matches('a') ? el : el.querySelector('a.glightbox, a.gallery-mix-lightbox');
    if (link && url) {
        link.href = url;
    }
}

function setImageUrl(el, url) {
        el.querySelectorAll('source').forEach((source) => source.remove());
    el.querySelectorAll('img').forEach((img) => {
        applyFocalPoint(img, url);
        const current = img.getAttribute('src') || '';
        if (current === url && !img.getAttribute('srcset') && !img.srcset) {
            img.removeAttribute('data-src');
            return;
        }
        // srcset-Property extra leeren: Safari behält sonst den alten BIS-Kandidat.
        img.srcset = '';
        img.sizes = '';
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.removeAttribute('data-src');
        img.src = url;
    });
    updateLinkHref(el, el.dataset.konfigPendingUrl || url);
}

const decodedUrls = {};
const prefetchedUrls = {};

function loadDecoded(url) {
    if (!url) {
        return Promise.resolve();
    }
    if (decodedUrls[url]) {
        return decodedUrls[url];
    }
    const job = new Promise((resolve) => {
        const probe = new Image();
        let settled = false;
        const finish = () => {
            if (settled) {
                return;
            }
            settled = true;
            if (typeof probe.decode === 'function') {
                probe.decode().then(resolve, resolve);
            } else {
                resolve();
            }
        };
        probe.onload = finish;
        probe.onerror = finish;
        probe.src = url;
        if (probe.complete && probe.naturalWidth) {
            finish();
        }
    });
    decodedUrls[url] = job;
    return job;
}

function applySlotImage(el, url) {
    if (!url) {
        return Promise.resolve();
    }
    const token = String((parseInt(el.dataset.konfigToken, 10) || 0) + 1);
    el.dataset.konfigToken = token;
    const img = el.querySelector('img');
    const hasSrc = !!(img && img.getAttribute('src'));
    if (sameCombo(el, url) && hasSrc) {
        updateLinkHref(el, url);
        if (img && !isBisCropSrc(img.getAttribute('src') || img.currentSrc || '')) {
            applyFocalPoint(img, url);
        }
        return Promise.resolve();
    }
    const deferred = img ? img.getAttribute('data-src') : '';
    const displayUrl = sameCombo(el, url) && deferred ? deferred : url;
    return loadDecoded(displayUrl).then(() => {
        if (el.dataset.konfigToken !== token) {
            return;
        }
        setImageUrl(el, displayUrl);
    });
}

function slotHasSrc(el) {
    const img = el.querySelector('img');
    return !!(img && img.getAttribute('src'));
}

function prefetchSlot(el, url) {
    if (!url) {
        return;
    }
    el.dataset.konfigPendingUrl = url;
    if (sameCombo(el, url) && slotHasSrc(el)) {
        return;
    }
    prefetchUrl(url);
}

function prefetchUrl(url) {
    if (!url || prefetchedUrls[url]) {
        return;
    }
    prefetchedUrls[url] = true;
    loadDecoded(url);
}

function prefetchKuecheSlots(code, files) {
    const ks = normalizeKueche(code);
    document.querySelectorAll('.js-konfig-image[data-konfig-kueche]').forEach((el) => {
        if (el.dataset.konfigKueche !== ks) {
            return;
        }
        prefetchSlot(el, targetUrlForSlot(el, files || window.lmKonfigFiles || {}));
    });
}

function prefetchForOption(option) {
    const key = option.dataset.filterSlug;
    const value = option.dataset.value;
    if (!key || !value) {
        return;
    }
    const files = window.lmKonfigFiles || {};
    if (key === 'kueche') {
        prefetchKuecheSlots(value, files);
        return;
    }
    const codes = { ...getKonfig(), [key]: value };
    document.querySelectorAll('.js-konfig-image').forEach((el) => {
        const scene = el.dataset.konfigScene;
        if (!scene) {
            return;
        }
        const slotCodes = { ...codes };
        if (el.dataset.konfigKueche) {
            slotCodes.kueche = el.dataset.konfigKueche;
        }
        const url = bestUrlForScene(scene, slotCodes, files) || el.dataset.fallbackUrl;
        if (url) {
            prefetchUrl(url);
        }
    });
}

function prefetchDeferredSlots() {
    const files = window.lmKonfigFiles || {};
    document.querySelectorAll('.js-konfig-image').forEach((el) => {
        if (!isDeferredSlot(el)) {
            return;
        }
        prefetchSlot(el, el.dataset.konfigPendingUrl || targetUrlForSlot(el, files));
    });
}

let idlePrefetchHandle = 0;
let idlePrefetchTimeout = 0;
let idlePrefetchLoadArmed = false;

function scheduleIdlePrefetch() {
    const arm = () => {
        const run = prefetchDeferredSlots;
        if (typeof window.cancelIdleCallback === 'function' && idlePrefetchHandle) {
            window.cancelIdleCallback(idlePrefetchHandle);
            idlePrefetchHandle = 0;
        }
        if (idlePrefetchTimeout) {
            window.clearTimeout(idlePrefetchTimeout);
            idlePrefetchTimeout = 0;
        }
        if (typeof window.requestIdleCallback === 'function') {
            idlePrefetchHandle = window.requestIdleCallback(run, { timeout: 1500 });
            return;
        }
        idlePrefetchTimeout = window.setTimeout(run, 400);
    };
    if (document.readyState !== 'complete') {
        if (!idlePrefetchLoadArmed) {
            idlePrefetchLoadArmed = true;
            window.addEventListener(
                'load',
                () => {
                    idlePrefetchLoadArmed = false;
                    arm();
                },
                { once: true }
            );
        }
        return;
    }
    arm();
}

let applyGen = 0;
let slotGen = 0;

function notifyApplied() {
    afterApplyHooks.forEach((fn) => fn());
}

function revealKuecheSlots(next) {
    if (!hasKuecheFilter()) {
        applyKuecheSlotVisibility();
        return;
    }
    const gen = ++slotGen;
    const files = window.lmKonfigFiles || {};
    const incoming = [];
    document.querySelectorAll('.js-konfig-image[data-konfig-kueche]').forEach((el) => {
        if (el.dataset.konfigKueche !== next) {
            return;
        }
        const url = targetUrlForSlot(el, files);
        if (!url) {
            return;
        }
        el.dataset.konfigPendingUrl = url;
        incoming.push(applySlotImage(el, url));
    });
    Promise.all(incoming).then(() => {
        if (gen !== slotGen) {
            return;
        }
        applyKuecheSlotVisibility();
        notifyApplied();
        scheduleIdlePrefetch();
    });
}

const afterApplyHooks = [];

export function onKonfigImagesApplied(fn) {
    afterApplyHooks.push(fn);
}

export function applyKonfigImages() {
    const gen = ++applyGen;
    const files = window.lmKonfigFiles || {};
    const jobs = [];
    document.querySelectorAll('.js-konfig-image').forEach((el) => {
        const url = targetUrlForSlot(el, files);
        if (!url) {
            return;
        }
        el.dataset.konfigPendingUrl = url;
        if (isDeferredSlot(el)) {
            return;
        }
        jobs.push(applySlotImage(el, url));
    });
    Promise.all(jobs).then(() => {
        if (gen !== applyGen) {
            return;
        }
        notifyApplied();
        scheduleIdlePrefetch();
    });
}

function summaryFor(bar, codes) {
    const parts = [];
    bar.querySelectorAll('.js-konfig-dropdown').forEach((dropdown) => {
        const key = dropdown.dataset.filterSlug;
        const opt = dropdown.querySelector(`.js-konfig-option[data-value="${codes[key]}"]`);
        parts.push(opt && opt.dataset.label ? opt.dataset.label : '');
    });
    return parts.filter(Boolean).join(' · ');
}

function uiCodes() {
    return { ...getKonfig(), kueche: getKuecheStandort() };
}

function syncUI(root = document) {
    const codes = uiCodes();
    root.querySelectorAll('.js-konfig-dropdown').forEach((dropdown) => {
        const key = dropdown.dataset.filterSlug;
        const value = codes[key];
        dropdown.querySelectorAll('.js-konfig-option').forEach((opt) => {
            const selected = opt.dataset.value === value;
            opt.classList.toggle('is-selected', selected);
            opt.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
        const selectedOpt = dropdown.querySelector(`.js-konfig-option[data-value="${value}"]`);
        const valueEl = dropdown.querySelector('.js-konfig-dropdown-value');
        if (valueEl && selectedOpt) {
            valueEl.textContent = selectedOpt.dataset.label || selectedOpt.textContent.trim();
        }
    });
    root.querySelectorAll('.konfig-sheet__chip.js-konfig-option').forEach((chip) => {
        const selected = chip.dataset.value === codes[chip.dataset.filterSlug];
        chip.classList.toggle('is-selected', selected);
        chip.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    root.querySelectorAll('.js-konfig-bar').forEach((bar) => {
        const text = bar.querySelector('.js-konfig-summary-text');
        if (text) {
            text.textContent = summaryFor(bar, codes);
        }
    });
}

export function syncSelects(root = document) {
    syncUI(root);
}

function closeDropdowns(except = null) {
    document.querySelectorAll('.js-konfig-dropdown.is-open').forEach((dropdown) => {
        if (dropdown === except) {
            return;
        }
        dropdown.classList.remove('is-open');
        const toggle = dropdown.querySelector('.js-konfig-dropdown-toggle');
        const menu = dropdown.querySelector('.js-konfig-dropdown-menu');
        if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
        }
        if (menu) {
            menu.hidden = true;
        }
    });
}

function openDropdown(dropdown) {
    closeDropdowns(dropdown);
    dropdown.classList.add('is-open');
    const toggle = dropdown.querySelector('.js-konfig-dropdown-toggle');
    const menu = dropdown.querySelector('.js-konfig-dropdown-menu');
    if (toggle) {
        toggle.setAttribute('aria-expanded', 'true');
    }
    if (menu) {
        menu.hidden = false;
    }
}

function sheetForBar(bar) {
    const opener = bar.querySelector('.js-konfig-sheet-open[aria-controls]');
    const id = opener && opener.getAttribute('aria-controls');
    if (id) {
        return document.getElementById(id);
    }
    return document.querySelector('.js-konfig-sheet');
}

function closeSheets() {
    document.querySelectorAll('.js-konfig-sheet').forEach((sheet) => {
        sheet.hidden = true;
        sheet.classList.remove('is-open');
    });
    document.querySelectorAll('.js-konfig-sheet-open').forEach((opener) => {
        opener.setAttribute('aria-expanded', 'false');
    });
    document.body.classList.remove('konfig-sheet-open');
}

function openSheet(bar) {
    closeDropdowns();
    const sheet = sheetForBar(bar);
    if (!sheet) {
        return;
    }
    sheet.hidden = false;
    sheet.classList.add('is-open');
    document.body.classList.add('konfig-sheet-open');
    bar.querySelectorAll('.js-konfig-sheet-open').forEach((opener) => {
        opener.setAttribute('aria-expanded', 'true');
    });
    const focusEl = sheet.querySelector('.js-konfig-sheet-focus');
    if (focusEl) {
        focusEl.focus();
    }
}

function modalRoot(el) {
    return el.closest('.modal--holder') || el.closest('.gslide') || el.closest('.ginner-container');
}

function navOffset(el) {
    const top = getComputedStyle(el).top;
    return parseFloat(top) || 0;
}

function bindSticky(bar) {
    if (bar.dataset.konfigStickyBound) {
        return;
    }
    bar.dataset.konfigStickyBound = '1';
    if (!bar.parentNode) {
        return;
    }
    const sentinel = document.createElement('div');
    sentinel.className = 'konfig-bar__sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    bar.parentNode.insertBefore(sentinel, bar);
    const offset = Math.round(navOffset(bar));
    const io = new IntersectionObserver(
        ([entry]) => {
            bar.classList.toggle('is-stuck', !entry.isIntersecting);
        },
        { threshold: 0, rootMargin: `-${offset}px 0px 0px 0px` }
    );
    io.observe(sentinel);
}

function bindDelegation() {
    document.addEventListener('pointerover', (event) => {
        const option = event.target.closest('.js-konfig-option');
        if (option) {
            prefetchForOption(option);
            return;
        }
        const tab = event.target.closest('.js-ks-tab');
        if (tab && tab.getAttribute('data-ks')) {
            prefetchKuecheSlots('ks' + String(tab.getAttribute('data-ks')).replace(/^ks/, ''));
        }
    });

    document.addEventListener('click', (event) => {
        const toggle = event.target.closest('.js-konfig-dropdown-toggle');
        if (toggle) {
            event.preventDefault();
            event.stopPropagation();
            const dropdown = toggle.closest('.js-konfig-dropdown');
            if (!dropdown) {
                return;
            }
            if (dropdown.classList.contains('is-open')) {
                closeDropdowns();
            } else {
                openDropdown(dropdown);
            }
            return;
        }

        const option = event.target.closest('.js-konfig-option');
        if (option) {
            event.preventDefault();
            event.stopPropagation();
            if (option.dataset.filterSlug === 'kueche') {
                setKuecheStandort(option.dataset.value);
                closeDropdowns();
                return;
            }
            setKonfigValue(option.dataset.filterSlug, option.dataset.value);
            closeDropdowns();
            syncUI();
            return;
        }

        const sheetOpen = event.target.closest('.js-konfig-sheet-open');
        if (sheetOpen) {
            event.preventDefault();
            if (window.matchMedia && window.matchMedia(MQ_DESKTOP).matches) {
                return;
            }
            const bar = sheetOpen.closest('.js-konfig-bar');
            if (bar) {
                openSheet(bar);
            }
            return;
        }

        const sheetClose = event.target.closest('.js-konfig-sheet-close');
        if (sheetClose) {
            event.preventDefault();
            closeSheets();
            return;
        }

        if (!event.target.closest('.js-konfig-dropdown')) {
            closeDropdowns();
        }

        const editBtn = event.target.closest('.js-konfig-edit');
        if (editBtn) {
            event.preventDefault();
            const modal = modalRoot(editBtn);
            if (!modal) {
                return;
            }
            const editors = modal.querySelector('.wohnung--konfig-editors');
            if (editors) {
                editors.classList.toggle('hidden');
                syncUI(modal);
            }
        }

        const clearBtn = event.target.closest('.js-konfig-clear');
        if (clearBtn) {
            event.preventDefault();
            clearKonfig();
            const modal = modalRoot(clearBtn);
            if (modal) {
                syncUI(modal);
            }
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') {
            return;
        }
        closeDropdowns();
        closeSheets();
    });

    if (window.matchMedia) {
        const mq = window.matchMedia(MQ_DESKTOP);
        const onChange = (event) => {
            if (event.matches) {
                closeSheets();
            } else {
                closeDropdowns();
            }
        };
        if (mq.addEventListener) {
            mq.addEventListener('change', onChange);
        } else if (mq.addListener) {
            mq.addListener(onChange);
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    persistValidCookie();
    document.querySelectorAll('.js-konfig-bar').forEach((bar) => {
        bindSticky(bar);
        const sheet = bar.querySelector('.js-konfig-sheet');
        if (sheet) {
            sheet.hidden = true;
            sheet.classList.remove('is-open');
            document.body.appendChild(sheet);
        }
    });
    applyKuecheSlotVisibility();
    syncUI();
    applyKonfigImages();
    bindDelegation();
});
